import { useState, useEffect } from 'react'
import { getTsgAccess } from '@sparky/framework'
import { SPARKY_ACCESS_NONE, SPARKY_ACCESS_READ } from '../constants/GlobalConstants'
import { getVarValue } from '../utils/Sparky'
import { FF_COMMON_SERVICES_CUSTOM_ROLES } from '../utils/FeatureFlags'

const customRolesEnabled = getVarValue(FF_COMMON_SERVICES_CUSTOM_ROLES, false)

const fetchVisible = async (tsg_id: string, permSet: string) => {
  if (customRolesEnabled && tsg_id) {
    return await getTsgAccess(tsg_id).then((tsgAccess) => {
      const access = (tsgAccess as any)?.checkPermissionSet(permSet)
      return access === SPARKY_ACCESS_READ || access === SPARKY_ACCESS_NONE
    })
  }
  return false
}

export default function useReadOnly(tsg_id: string, permSet: string) {

  const [readOnly, setReadOnly] = useState(true)

  useEffect(() => {
    let mounted = true
    fetchVisible(tsg_id, permSet).then(visible => {
      if (mounted) {
        setReadOnly(visible)
      }
    })
    return () => {
      mounted = false
    }
  }, [tsg_id, permSet])

  return readOnly
}
